/**
 * Created by Rodrigo Quesada on 05/02/17.
 */
import {Injectable} from '@angular/core';
import {AbpsBoard} from './abps-board.model';
import {Service} from '../../../common/service.class';
import {UserModelListService} from '../../../common/user-model-list.service';

@Injectable()
export class AbpsBoardService extends UserModelListService<AbpsBoard> {

    constructor(svcm: Service.InjectedMembers) {
        super(svcm, 'abpsBoard', AbpsBoard);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/domain/model/licenses-certifications/board/abps/abps-board.service.ts